// The rep's CRM signature (sales.prefs.email_signature_html) appended to an email body. One rule for the 1:1 compose
// drawer (src/components/gavion/integrations/compose/composeModel.ts re-exports withSignature) and the sequence runner
// (GAVION campaign-fixes, through compose.ts's ComposeSystem.signatureHtml). Callers sanitise the signature first.

/** The body, an empty paragraph, then the signature; no signature → the body unchanged. */
export const withSignature = (html: string, signature: string): string =>
  signature ? `${html}<p></p>${signature}` : html;

/** A signature with nothing to show (no text, no image) counts as none. */
export const isBlankSignature = (html: string | null | undefined): boolean =>
  !html ||
  (!/<img\b/i.test(html) &&
    html.replace(/<[^>]*>/g, "").replace(/&nbsp;|\s/g, "") === "");
